export enum SportStatInputType {
  SelectParticipant = 'select-participant',
  Number = 'number',
}
